import { LuneThemeNew, Text } from '@lune-fe/lune-ui-lib'
import { Box } from '@mui/material'
import { FC, MouseEvent, ReactNode } from 'react'

const { palette } = LuneThemeNew

interface LegCardProps {
    active: boolean
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void
    label: ReactNode
    title?: ReactNode
    amount?: ReactNode
    dataTestId?: string
    amountTestId?: string
    compact?: boolean
}

export const LegCard: FC<LegCardProps> = ({
    active,
    onClick,
    label,
    title,
    amount,
    dataTestId,
    amountTestId,
    compact = false,
}) => {
    return (
        <Box
            data-testid={dataTestId}
            onClick={onClick}
            component={'button'}
            sx={{
                background: active ? palette.Blue50 : palette.Grey100,
                mt: 1,
                mb: 1,
                height: '160px',
                borderRadius: '16px',
                p: 2,
                minWidth: '120px',
                maxWidth: active ? '320px' : compact ? '122px' : '160px',
                width: active ? '320px' : '100%',
                flex: '1 0 auto',
                transition: 'background .15s ease-in-out',
                overflow: 'hidden',
                cursor: onClick ? 'pointer' : 'default',
                border: 'none',
                textAlign: 'left',
                display: 'flex',
                alignItems: 'space-between',
                justifyContent: 'space-between',
                flexDirection: 'column',
            }}
        >
            <Box
                sx={{
                    padding: '10px 14px 10px 12px',
                    borderRadius: '40px',
                    background: active ? palette.Blue500 : palette.Grey300,
                    transition: 'background .15s ease-in-out',
                    color: active ? palette.White : palette.Grey900,
                    svg: {
                        height: '20px',
                        width: '20px',
                    },
                    span: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    },
                }}
            >
                <Text variant={'button'}>{label}</Text>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                }}
            >
                {title && (
                    <Text
                        variant={'body2'}
                        sx={{
                            width: '100%',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {title}
                    </Text>
                )}
                {amount && (
                    <Text variant={'caption'} data-testid={amountTestId}>
                        {amount}
                    </Text>
                )}
            </Box>
        </Box>
    )
}

export default LegCard
